module.exports = __webpack_public_path__ + "prod/1.42.2/img/xiecheng-icon.78dee9a1.png";